/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import { TableRow } from '@mui/material';
import TableCell from 'src/components/Table/TableCell';
import { formatAmount } from 'src/utils/formatAmout';
import selectFormatDate from 'src/utils/selectDateFormat';
import dateFormatType from 'src/utils/dateFormatType';

const AgingBalanceResumeRow = ({
  date,
  upToDate,
  from1To30Days,
  from31To60Days,
  from61To90Days,
  from91To120Days,
  over120Days,
  total
}) => {
  return (
    <TableRow hover>
      <TableCell align="left">
        {selectFormatDate(date, dateFormatType.DAY)}
      </TableCell>
      <TableCell align="left" sx={{ fontWeight: 'bold' }}>
        {formatAmount(total)}
      </TableCell>
      <TableCell align="left">{formatAmount(upToDate)}</TableCell>
      <TableCell align="left">{formatAmount(from1To30Days)}</TableCell>
      <TableCell align="left">{formatAmount(from31To60Days)}</TableCell>
      <TableCell align="left">{formatAmount(from61To90Days)}</TableCell>
      <TableCell align="left">{formatAmount(from91To120Days)}</TableCell>
      <TableCell align="left">{formatAmount(over120Days)}</TableCell>
    </TableRow>
  );
};

AgingBalanceResumeRow.propTypes = {
  date: PropTypes.string.isRequired,
  upToDate: PropTypes.number.isRequired,
  from1To30Days: PropTypes.number.isRequired,
  from31To60Days: PropTypes.number.isRequired,
  from61To90Days: PropTypes.number.isRequired,
  from91To120Days: PropTypes.number.isRequired,
  over120Days: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired
};

export default AgingBalanceResumeRow;
